<template>
  <div id="OrgDetail">
    <eb-header>
      <eb-break-crumb slot="breakCrumb"/>
    </eb-header>
    <div class="content-header">
      <OrgViewHeaderCard>
        <OrgViewHeaderQuotationCard :orgInfo="orgInfo" :user="user"></OrgViewHeaderQuotationCard>
      </OrgViewHeaderCard>
    </div>
    <div class="eb-line"></div>
    <div id="content-info" class="panel-box">
      <OrgViewInfo :orgInfo="orgInfo" :user="user"></OrgViewInfo>
    </div>
    <div class="eb-line"></div>
    <div id="content-business" class="panel-box">
      <OrgRealNameTime :orgInfo="orgInfo" :realAutheTime="realAutheTime"></OrgRealNameTime>
    </div>
    <div class="eb-line"></div>
    <div id="content-business" class="panel-box">
      <OrgAccountInfo :orgInfo="orgInfo"></OrgAccountInfo>
    </div>
    <div class="eb-line"></div>
    <div id="content-business" class="panel-box">
      <OrgViewTradeArea :orgInfo="orgInfo"></OrgViewTradeArea>
    </div>
    <div class="eb-line"></div>
    <div id="content-aptitude" class="panel-box">
      <OrgViewQualification :orgAptitudeFileArr="orgAptitudeFileArr"></OrgViewQualification>
    </div>
    <div class="eb-line"></div>
    <div id="content-team" class="panel-box">
      <OrgViewTeam :companyTeamList="companyTeamList"></OrgViewTeam>
    </div>

    <OrgTeamDetailDialog></OrgTeamDetailDialog>
    <OrgRealNameAuthenticationConfirm/>
  </div>
</template>

<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import OrgViewHeaderCard from '@/components/org/view/OrgViewHeaderCard';
import OrgViewHeaderQuotationCard from '@/components/org/view/OrgViewHeaderQuotationCard';
import OrgViewInfo from '@/components/org/view/OrgViewInfo';
import OrgRealNameTime from '@/components/org/view/OrgRealNameTime';
import OrgAccountInfo from '@/components/org/view/OrgAccountInfo';
import OrgViewTradeArea from '@/components/org/view/OrgViewTradeArea';
import OrgViewQualification from '@/components/org/view/OrgViewQualification';
import OrgViewTeam from '@/components/org/view/OrgViewTeam';
import OrgTeamDetailDialog from '@/components/org/common/OrgTeamDetailDialog';
import OrgRealNameAuthenticationConfirm from '@/components/org/view/OrgRealNameAuthenticationConfirm';
import { getDepartmentById, listDepartFile } from '@/services/org/depart-service';
import { getUserByIds } from '@/services/user/user-service';
import { queryPayInfo } from '@/services/org/depart-realname-service';
export default {
  name: 'OrgDetail',
  components: {
    ebHeader,
    ebBreakCrumb,
    OrgViewHeaderCard,
    OrgViewHeaderQuotationCard,
    OrgViewInfo,
    OrgRealNameTime,
    OrgAccountInfo,
    OrgViewTradeArea,
    OrgViewQualification,
    OrgViewTeam,
    OrgTeamDetailDialog,
    OrgRealNameAuthenticationConfirm
  },
  data() {
    return {
      departId: '',
      user: this.$store.state.user.userInfo,
      orgInfo: {},
      companyTeamList: [],
      orgAptitudeFileArr: [],
      routerParams: this.$route.params.departId,
      realAutheTime: {}
    };
  },
  created() {
    this.getDepartmentById();
    this.loadOrgAptitudeFile();
    this.realNameDeadline();
  },
  methods: {
    async getDepartmentById() {
      try {
        let departId = '';
        if (this.routerParams !== undefined) {
          departId = this.routerParams;
        } else {
          departId = this.user.orgId;
        }
        let { data } = await getDepartmentById(departId);
        if (data.returnCode === '01') {
          this.orgInfo = data.depart;
          this.loadOrgTeamMember(this.orgInfo.companyTeam);
        } else {
          this.$message.error('加载企业信息失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async loadOrgTeamMember(companyTeam) {
      if (companyTeam == null || companyTeam === '') {
        this.companyTeamList = [];
        return;
      }
      let orgUserIdArr = companyTeam && companyTeam !== '' ? companyTeam.split(',') : ['', '', '', '', ''];

      let orgUserIds = companyTeam.split(',').filter(function(userId) {
        return userId !== '';
      }).join(',');

      if (orgUserIds === '') {
        this.companyTeamList = [];
        return;
      }
      try {
        let { data } = await getUserByIds(orgUserIds);
        if (data.returnCode === '01') {
          this.companyTeamList = data.userList;
          let companyTeamListTemp = [];
          let orgUserIdArrLen = orgUserIdArr.length;
          let userListLen = data.userList.length;
          for (let i = 0; i < orgUserIdArrLen; i++) {
            for (let j = 0; j < userListLen; j++) {
              let orgUserId = orgUserIdArr[i];
              let userId = data.userList[j]['userId'].toString();
              if (orgUserId === userId) {
                companyTeamListTemp.push(data.userList[j]);
              }
            }
          }
          this.companyTeamList = companyTeamListTemp;
        } else {
          this.$message.error('加载机构团队成员信息失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    async loadOrgAptitudeFile() {
      let orgId = this.user.orgId;
      try {
        let { data } = await listDepartFile(orgId);
        if (data.returnCode === '01') {
          this.orgAptitudeFileArr = data.data;
        } else {
          this.$message.error('加载企业资质文件失败！');
        }
        this.$root.layout.isLoading = false;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async realNameDeadline() {
      try {
        let departId = '';
        if (this.routerParams !== undefined) {
          departId = this.routerParams;
        } else {
          departId = this.user.orgId;
        }
        let { data } = await queryPayInfo(departId, 'SMRZ1804');
        if (data.returnCode === '01') {
          if (data.payInfo !== null) {
            this.realAutheTime = data.payInfo;
          }
        } else {
          throw new Error('获取实名认证支付信息失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    }
  }
};
</script>

<style scoped lang="less">
.content-header {
  padding: 33px 33px 33px 33px;
}
</style>
